import { Button, Result } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';

const Notauthorized: React.FC = () => {
  const history = useHistory();

  //todo get french version using i18n => use translation
  return (
    <Result
      status="warning"
      title="you are not authorized"
      subTitle="you are not authorized"
      extra={
        <Button
          type="primary"
          onClick={() => {
            history.push('/')
          }}
        >
          Reload
        </Button>
      }
    />
  );
};

export default Notauthorized;
